import React from 'react';
import { TrendingUp, Users, Zap, Target, Video } from 'lucide-react';

const ExchangeAudience = () => {
  const scaleBenefits = [
    { icon: TrendingUp, text: 'Expand Training without adding headcount' },
    { icon: Users, text: 'Maintain consistency across teams and locations' },
    { icon: Zap, text: 'Respond quickly to new initiatives or skill gaps' },
    { icon: Target, text: 'Keep Training measurable and relevant' }
  ];

  const mediaServices = [
    'Professionally filmed Training modules',
    'High-quality audio, lighting, and editing',
    'Executive-level presentation standards',
    'Your expertise — delivered with enterprise polish'
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-6xl mx-auto space-y-20">
        {/* Built for Scale */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Built for <span className="text-cyan-400">Scale</span>
            </h2>
            <p className="text-xl text-gray-300">
              With Traain Exchange, organizations:
            </p>
          </div>

          <div className="max-w-3xl mx-auto grid md:grid-cols-2 gap-4">
            {scaleBenefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <p className="text-gray-300">{benefit.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Optional Media Production */}
        <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 border border-purple-500/30 rounded-2xl p-8 md:p-10">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
              <Video className="w-6 h-6 text-purple-400" />
            </div>
            <div>
              <p className="text-sm text-purple-400 font-semibold uppercase tracking-wide mb-1">Optional</p>
              <h3 className="text-2xl font-bold text-white">
                Professional Media Production
              </h3>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-6">
            Want studio-quality Training? Traain offers a custom media add-on for:
          </p>

          <div className="space-y-3 mb-6">
            {mediaServices.map((service, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-300">{service}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExchangeAudience;
